import ManagedEDR from './ManagedEDR';

export default ManagedEDR;
export { ManagedEDR };
